import { constants } from "buffer";
import { FieldsLengthConstants, NatureOfBusiness, RequestStatus, RequestStatusLabel, RequestTypes, VendorCategoryData } from "../constants/AppConstants";
import { PaymentMethod } from "../models/PaymentMethod";
import { VendorDetailState } from "../reducers/vendor/VendorDetailReducer";
import { Po } from "../models/Po";

function getEnumKeyByEnumValue<T extends {[index:string]:string}>(myEnum:T, enumValue:string):keyof T|null {
    let keys = Object.keys(myEnum).filter(x => myEnum[x] == enumValue);
    return keys.length > 0 ? keys[0] : null;
}

function getDisplayDateString (date:Date) {
    var date = new Date(date);
    var newdate= (date.getMonth() + 1) + '/' + date.getDate() + '/' +  date.getFullYear();
    return newdate;
}

function getDisplayStatus (requestStatus:number) {
    switch(requestStatus){ 
        case RequestStatus.Pending: return RequestStatusLabel.Pending;
        case RequestStatus.Initial: return RequestStatusLabel.Initial;
        case RequestStatus.Complete: return RequestStatusLabel.Complete;
        case RequestStatus.Rejected: return RequestStatusLabel.Rejected;
        case RequestStatus.Cancelled: return RequestStatusLabel.Cancelled;
        default : return "";
    }
}

function getVendorStatusId (requestStatus:string) {
    switch(requestStatus){ 
        case RequestStatusLabel.Pending: return RequestStatus.Pending;
        case RequestStatusLabel.Initial: return RequestStatus.Initial;
        case RequestStatusLabel.Complete: return RequestStatus.Complete;
        case RequestStatusLabel.Rejected: return RequestStatus.Rejected;
        case RequestStatusLabel.Cancelled: return RequestStatus.Cancelled;
        default : return 0;
    }
}

const concateStringArray = (datalist: any) => {
    if (datalist && datalist.length > 0) {
      let concatstring = datalist.join(",");
      return concatstring;
    }
    return "";
  };

const getBankNameFromVendorName = (vendorDetail:VendorDetailState) => {
    if((vendorDetail.NatureOfbusiness == NatureOfBusiness.Partnership
        || vendorDetail.NatureOfbusiness == NatureOfBusiness.SolePropritery) && vendorDetail.VendorName){
        return vendorDetail.VendorName.substring(0, (FieldsLengthConstants.BeneficiaryAccName));
    }
    return "";
};

const excludeIsIndividualPaymentMethod = (paymentMethodList: PaymentMethod[]): PaymentMethod[] => {
    const index = paymentMethodList.map(i => i.code).indexOf('H');
    if (index > 0) {
        const filteredMethods = [...paymentMethodList];
        filteredMethods.splice(index, 1);
        return filteredMethods;
    } else {
        return paymentMethodList
    }
};

const hasSpecialCharacters = (text: string): boolean => {
    if(text && text.trim()){
        let specialChars = ['~', '!', '@', '#', '$', '%', '^', '=', '\\', '_', '{', '}', '[', ']', '>', '‘', '“', 'Ä', 'ä', 'Ö', 'ö', '&', '*', ';', '<', 'Ü', 'ü', 'ß'];
        let hasSpecialChar = specialChars.find(s => text.indexOf(s) > -1);
        return hasSpecialChar ? true : false;
    }
    return false;
};

const sortObjByString = (array: object[], prop: string) => {
    return array 
        ? array.sort((p1: any, p2: any) => { 
            return p1[prop].toLowerCase() <= p2[prop].toLowerCase() ? -1 : 1 })
        : array;    
}

const getSampleBulkPoList = (poList: Po[], vendorCategoryId: number, isBulk: boolean, requestTypeId: number) => {
    if (poList && vendorCategoryId == VendorCategoryData.RM) {
        if (isBulk) {
            return requestTypeId == RequestTypes.VendorExtend 
                ? poList
                : poList.filter(p => {
                        return p.code.substring(p.code.length - 1) != "2";
                    });
        } else {
        return poList.filter(p => {
            return p.code.substring(p.code.length - 1) == "2";
        });
        }
    } else {
        return vendorCategoryId > 0 ? poList : [];
    }
}

export const Util = {
    getEnumKeyByEnumValue,
    getDisplayDateString,
    getDisplayStatus,
    getVendorStatusId,
    concateStringArray,
    getBankNameFromVendorName,
    excludeIsIndividualPaymentMethod,
    hasSpecialCharacters,
    sortObjByString,
    getSampleBulkPoList
};
